import React, { useEffect, useState } from "react";
import { Box, Modal, TextField, Typography } from "@mui/material";
import Navbar from "../../Components/Navbar";
import CustomButton from "../../Components/Button";
import axios from "axios";
import { updateVat } from "../../Redux/LoginReduces";
import { useDispatch, useSelector } from "react-redux";
import { Base_Uri, Image_Uri } from "../../Constant/BaseUri";
import { RingLoader } from "react-spinners";
import { Colors } from "../../Constant/Color";
import moment from "moment/moment";
import BasicSelect from "../../Components/Dropdown";
import { Checkbox, message, Select, Tree } from "antd";

function CompanyInformation() {
  const dispatch = useDispatch();

  const Information = useSelector((state) => state.loginReducer.vat);
  const userData = useSelector((state) => state.loginReducer.updatedState);
  const [data, setData] = useState(Information.role_access||[]);
  useEffect(()=>{
    console.log("hello")
setData(Information.role_access||[])
  },[Information])
  const [companyInformation, setCompanyInformation] = useState({
    companyName: Information?.companyName,
    companyLogo: Information?.companyLogo,
    city: Information?.city,
    postCode: Information?.postCode,
    companyAddress: Information?.companyAddress,
    companyEmail: Information?.companyEmail,
    mobileNumber: Information?.mobileNumber,
    companyNumber: Information?.companyNumber,
    vatNumber: Information?.vatNumber,
    vatRate: Information?.vatRate,
    startTime: Information?.startTime,
    endTime: Information?.posEndTime,
    currency: Information?.currency,
    _id: Information?._id,
    defualtCustomer: Information?.defualtCustomer,
  });
  const [checkedKeys, setCheckedKeys] = useState([]);

  const convertToTreeData = (data) => {
    return data.map(item => ({
      title: item.name,
      key: item.id,
      children: item.child ? convertToTreeData(item.child) : undefined,
    }));
  };

  // Helper: Get all checked ids from your data
  const getAllCheckedIds = (data) => {
    let result = [];
    data.forEach(item => {
      if (item.is) {
        result.push(item.id);
      }
      if (item.child) {
        result = result.concat(getAllCheckedIds(item.child));
      }
    });
    return result;
  };

  // When check/uncheck happens
  const onCheck = (checkedKeysValue) => {
    const updateIs = (data, checkedKeys) => {
      return data.map(item => {
        const isChecked = checkedKeys.includes(item.id);
        return {
          ...item,
          is: isChecked,
          child: item.child ? updateIs(item.child, checkedKeys) : undefined,
        };
      });
    };

    const updatedData = updateIs(data, checkedKeysValue);
    setData(updatedData);
    setCheckedKeys(checkedKeysValue);
    setCompanyInformation((is)=>({...is,role_access:updatedData}))
    console.log(updatedData,"updateData")
  };
  const [imagePreview, setImagePreview] = useState("");

  const [selectedFile, setSelectedFile] = useState("");

  useEffect(() => {
    const startTime = Information?.startTime;

    const endTime = Information?.endTime;

    let formattedTime;

    if (startTime) {
      const [hours, minutes] = startTime.split(":");

      // Create a moment object and set the hours and minutes
      const date = moment()
        .hours(parseInt(hours, 10))
        .minutes(parseInt(minutes, 10));

      // Use Moment.js to format the time in the desired format
      formattedTime = date.format("HH:mm");
    }

    let endFormatTime;

    if (endTime) {
      const [hours, minutes] = endTime.split(":");

      // Create a moment object and set the hours and minutes
      const date = moment()
        .hours(parseInt(hours, 10))
        .minutes(parseInt(minutes, 10));
      endFormatTime = date.format("HH:mm");
    }
setData(data)
    setCompanyInformation({
      companyName: Information?.companyName,
      companyAddress: Information?.companyAddress,
      companyEmail: Information?.companyEmail,
      mobileNumber: Information?.mobileNumber,
      companyNumber: Information?.companyNumber,
      vatNumber: Information?.vatNumber,
      vatRate: Information?.vatRate,
      startTime: formattedTime,
      city: Information?.city,
      postCode: Information?.postCode,
      endTime: endFormatTime,
      companyLogo: Information?.companyLogo,
      _id: Information?._id,
      currency: Information?.currency,
      defualtCustomer: Information?.defualtCustomer,
    });
  }, [Information?._id]);

  const [loading, setLoading] = useState(false);

  function objectToFormData(obj) {
    const formData = new FormData();
  
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        const value = obj[key];
  
        if (typeof value === 'object' && value !== null) {
          formData.append(key, JSON.stringify(value));
        } else {
          formData.append(key, value);
        }
      }
    }
  
    return formData;
  }
  

  const handleSaveCompanyInformation = async () => {
    let flag = Object.values(companyInformation).some((e, i) => !e);

    if (flag) {
      message.info("Required fields are missing");
      return;
    }

    setLoading(true);

    const formData = await objectToFormData(companyInformation);
    formData.append("companyImage", selectedFile);

    let data = await sessionStorage.getItem("userData");
    data = JSON.parse(data);
    let token = data;
console.log(companyInformation)
    if (token) {
      axios
        .put(`${Base_Uri}changeCompanyInfomation`, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        })
        .then((res) => {
          let data = res.data;

          if (!data?.status) {
            setLoading(false);
            message.info(data?.message);
            return;
          }

          message.info(data.message);
          setLoading(false);
          dispatch(updateVat(data.data));
        })
        .catch((error) => {
          message.info(error?.message);
          setLoading(false);
          return;
        });
    }
  };

  const getVat = async () => {
    let data = sessionStorage.getItem("userData");
    data = JSON.parse(data);
    let token = data;

    axios
      .get(`${Base_Uri}getVat`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json", // Include other headers as needed
        },
      })
      .then((res) => {
        let { data } = res;

        if (data.status) {
          dispatch(updateVat(data.data));
        }
      })
      .catch((error) => {});
  };

  useEffect(() => {
    getVat();
  }, []);

  const handleImageChange = (event) => {
    const file = event.target.files[0];

    setSelectedFile(file);
    const reader = new FileReader();
    reader.onload = (e) => {
      setImagePreview(e.target.result);
    };
    reader.readAsDataURL(file);
  };

  const [appPassword, setAppPassword] = useState("");
  const [emailConnectionModal, setEmailConnectionModal] = useState(false);
const [customerData,setCustomerData] = useState([])
  useEffect(()=>{
    let data = sessionStorage.getItem("userData");
    data = JSON.parse(data);
    let token = data;
axios.get(`${Base_Uri}getCustomers`,{
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }).then((data)=>{
            console.log(data.data)
setCustomerData(data.data.data)
          })
  },[])
  const ConnectEmail = () => {
    setLoading(true);
    if (!appPassword.length > 0) {
      message.info("App Password is Required");
      setLoading(false);
    }
    let data = sessionStorage.getItem("userData");
    data = JSON.parse(data);
    let token = data;
    if (token) {
      axios
        .put(
          `${Base_Uri}connectEmail`,
          { _id: Information._id, appPassword },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        )
        .then((res) => {
          let data = res.data;

          if (!data?.status) {
            setLoading(false);
            message.info(data?.message);
            return;
          }

          message.info(data.message);
          setLoading(false);
          setEmailConnectionModal(false);
          setAppPassword("");
          dispatch(updateVat(data.data));
        })
        .catch((error) => {
          message.info(error?.message);
          setLoading(false);
          return;
        });
    }
  };

 
  return loading ? (
    <Box
      style={{
        width: "100vw",
        height: "80vh",
        justifyContent: "center",
        alignItems: "center",
        display: "flex",
      }}
    >
      <RingLoader loading={loading} size={100} color={Colors.black} />
    </Box>
  ) : (
    <Box>
      <Navbar currentPage="Company Information" />

      <Box
        style={{
          padding: 20,
          width: "100%",
          border: "2px solid",
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
        }}
      >
        <div>
          <label htmlFor="avatar">
            <img
              src={
                imagePreview
                  ? imagePreview
                  : `${Image_Uri}companyImage/${companyInformation?.companyLogo}`
              }
              className="avatar-image"
              style={{ width: 150, height: 150, borderRadius: 10 }}
            />
          </label>
          <input
            type="file"
            id="avatar"
            accept="image/*"
            style={{
              display: "none",
              border: "2px solid red",
              padding: 10,
            }}
            onChange={handleImageChange}
          />
        </div>
        {!Information?.appPassword && (
          <Box>
            <CustomButton
              onClick={() => setEmailConnectionModal(true)}
              style={{ width: 300 }}
              text="Connect Email"
            />
          </Box>
        )}

        {Information?.appPassword && (
          <Box>
            <div style={{ color: "green" }}>Email Succesfully Connected</div>
          </Box>
        )}
        {Information?.appPassword && (
          <Box>
            <CustomButton
              onClick={() => setEmailConnectionModal(true)}
              style={{ width: 300 }}
              text="Change App Password"
            />
          </Box>
        )}
        <Box>
          <Typography
            style={{
              fontFamily: "Poppins",
              fontSize: 18,
              fontWeight: "600",
              textAlign: "left",
            }}
          >
            Company Name:
          </Typography>

          <TextField
            variant="standard" // <== changed this
            margin="normal"
            required
            value={companyInformation?.companyName}
            onChange={(e) =>
              setCompanyInformation({
                ...companyInformation,
                companyName: e?.target?.value,
              })
            }
            InputProps={{
              disableUnderline: true,
              fontSize: "12px",
            }}
            placeholder="Enter Company Name"
            sx={{
              width: "400px",
              fontSize: "12px",
              padding: 1,
              borderRadius: 2,
              border: "1px solid black",
              fontFamily: "Poppins",
              fontWeight: "bold",
              margin: 0,
            }}
          />
        </Box>

        <Box style={{ marginTop: 10 }}>
          <Typography
            style={{
              fontFamily: "Poppins",
              fontSize: 18,
              fontWeight: "600",
              textAlign: "left",
            }}
          >
            Mobile Number:
          </Typography>

          <TextField
            variant="standard" // <== changed this
            margin="normal"
            required
            value={companyInformation?.mobileNumber}
            onChange={(e) =>
              setCompanyInformation({
                ...companyInformation,
                mobileNumber: e?.target?.value,
              })
            }
            InputProps={{
              disableUnderline: true,
              fontSize: "12px",
            }}
            placeholder="Enter Mobile Number"
            sx={{
              width: "400px",
              fontSize: "12px",
              padding: 1,
              borderRadius: 2,
              border: "1px solid black",
              fontFamily: "Poppins",
              fontWeight: "bold",
              margin: 0,
            }}
          />
        </Box>

        <Box style={{ marginTop: 10 }}>
          <Typography
            style={{
              fontFamily: "Poppins",
              fontSize: 18,
              fontWeight: "600",
              textAlign: "left",
            }}
          >
            Company Address:
          </Typography>

          <TextField
            variant="standard" // <== changed this
            margin="normal"
            required
            value={companyInformation?.companyAddress}
            onChange={(e) =>
              setCompanyInformation({
                ...companyInformation,
                companyAddress: e?.target?.value,
              })
            }
            InputProps={{
              disableUnderline: true,
              fontSize: "12px",
            }}
            placeholder="Enter Company Address"
            sx={{
              width: "400px",
              fontSize: "12px",
              padding: 1,
              borderRadius: 2,
              border: "1px solid black",
              fontFamily: "Poppins",
              fontWeight: "bold",
              margin: 0,
            }}
          />
        </Box>
        <Box style={{ marginTop: 10 }}>
          <Typography
            style={{
              fontFamily: "Poppins",
              fontSize: 18,
              fontWeight: "600",
              textAlign: "left",
            }}
          >
            City`:
          </Typography>

          <TextField
            variant="standard" // <== changed this
            margin="normal"
            required
            value={companyInformation?.city}
            onChange={(e) =>
              setCompanyInformation({
                ...companyInformation,
                city: e?.target?.value,
              })
            }
            InputProps={{
              disableUnderline: true,
              fontSize: "12px",
            }}
            placeholder="Enter Company City"
            sx={{
              width: "400px",
              fontSize: "12px",
              padding: 1,
              borderRadius: 2,
              border: "1px solid black",
              fontFamily: "Poppins",
              fontWeight: "bold",
              margin: 0,
            }}
          />
        </Box>
        <Box style={{ marginTop: 10 }}>
          <Typography
            style={{
              fontFamily: "Poppins",
              fontSize: 18,
              fontWeight: "600",
              textAlign: "left",
            }}
          >
            Currency:
          </Typography>

          <BasicSelect
            variant="standard" // <== changed this
            margin="normal"
            required
            width="400px"
            value={companyInformation?.currency}
            onChange={(e) =>
              setCompanyInformation({
                ...companyInformation,
                currency: e,
              })
            }
            id={{ rs: "RS", dollor: "$" }}
            InputProps={{
              disableUnderline: true,
              fontSize: "12px",
            }}
            placeholder="Select Currency"
            style={{ width: "400px" }}
            sx={{
              width: "400px",
              fontSize: "12px",
              padding: 1,
              borderRadius: 2,
              border: "1px solid black",
              fontFamily: "Poppins",
              fontWeight: "bold",
              margin: 0,
            }}
          />
        </Box>
        <Box style={{ marginTop: 10 }}>
          <Typography
            style={{
              fontFamily: "Poppins",
              fontSize: 18,
              fontWeight: "600",
              textAlign: "left",
            }}
          >
            Postal Code
          </Typography>

          <TextField
            variant="standard" // <== changed this
            margin="normal"
            required
            value={companyInformation?.postCode}
            onChange={(e) =>
              setCompanyInformation({
                ...companyInformation,
                postCode: e?.target?.value,
              })
            }
            InputProps={{
              disableUnderline: true,
              fontSize: "12px",
            }}
            placeholder="Enter Postal Code"
            sx={{
              width: "400px",
              fontSize: "12px",
              padding: 1,
              borderRadius: 2,
              border: "1px solid black",
              fontFamily: "Poppins",
              fontWeight: "bold",
              margin: 0,
            }}
          />
        </Box>

        <Box style={{ marginTop: 10 }}>
          <Typography
            style={{
              fontFamily: "Poppins",
              fontSize: 18,
              fontWeight: "600",
              textAlign: "left",
            }}
          >
            Company Email:
          </Typography>

          <TextField
            variant="standard" // <== changed this
            margin="normal"
            required
            value={companyInformation?.companyEmail}
            onChange={(e) =>
              setCompanyInformation({
                ...companyInformation,
                companyEmail: e?.target?.value,
              })
            }
            InputProps={{
              disableUnderline: true,
              fontSize: "12px",
            }}
            placeholder="Enter Company Email"
            sx={{
              width: "400px",
              fontSize: "12px",
              padding: 1,
              borderRadius: 2,
              border: "1px solid black",
              fontFamily: "Poppins",
              fontWeight: "bold",
              margin: 0,
            }}
          />
        </Box>

        <Box style={{ marginTop: 10 }}>
          <Typography
            style={{
              fontFamily: "Poppins",
              fontSize: 18,
              fontWeight: "600",
              textAlign: "left",
            }}
          >
            Company Number:
          </Typography>

          <TextField
            variant="standard" // <== changed this
            margin="normal"
            required
            value={companyInformation?.companyNumber}
            onChange={(e) =>
              setCompanyInformation({
                ...companyInformation,
                companyNumber: e?.target?.value,
              })
            }
            InputProps={{
              disableUnderline: true,
              fontSize: "12px",
            }}
            placeholder="Enter Company Number"
            sx={{
              width: "400px",
              fontSize: "12px",
              padding: 1,
              borderRadius: 2,
              border: "1px solid black",
              fontFamily: "Poppins",
              fontWeight: "bold",
              margin: 0,
            }}
          />
        </Box>

        <Box style={{ marginTop: 10 }}>
            <Typography
              style={{
                fontFamily: "Poppins",
                fontSize: 18,
                fontWeight: "600",
                textAlign: "left",
              }}
            >
              Defualt Customer:
            </Typography>

           <Select
  value={companyInformation?.defualtCustomer}
  onChange={(value) => {
    console.log(value, "Selected Customer ID");
    setCompanyInformation({
      ...companyInformation,
      defualtCustomer: value,
    });
  }}
  options={customerData?.map((e) => ({
    label: e?.businessName,
    value: e?.id,
  }))}
  style={{
    width: "400px",
    fontSize: "12px",
    height: 50,
    padding: 2,
    borderRadius: 2,
    fontFamily: "Poppins",
    fontWeight: "bold",
    margin: 0,
  }}
/>

          </Box>
        <Box
          style={{
            display: "flex",
            justifyContent: "space-between",
            width: "400px",
          }}
        >
          <Box style={{ marginTop: 10 }}>
            <Typography
              style={{
                fontFamily: "Poppins",
                fontSize: 18,
                fontWeight: "600",
                textAlign: "left",
              }}
            >
              Vat Number:
            </Typography>

            <TextField
              variant="standard" // <== changed this
              margin="normal"
              required
              value={companyInformation?.vatNumber}
              onChange={(e) =>
                setCompanyInformation({
                  ...companyInformation,
                  vatNumber: e?.target?.value,
                })
              }
              InputProps={{
                disableUnderline: true,
                fontSize: "12px",
              }}
              placeholder="Enter Vat Number"
              sx={{
                width: "190px",
                fontSize: "12px",
                padding: 1,
                borderRadius: 2,
                border: "1px solid black",
                fontFamily: "Poppins",
                fontWeight: "bold",
                margin: 0,
              }}
            />
          </Box>

          <Box style={{ marginTop: 10 }}>
            <Typography
              style={{
                fontFamily: "Poppins",
                fontSize: 18,
                fontWeight: "600",
                textAlign: "left",
              }}
            >
              Vat Rate %:
            </Typography>

            <TextField
              variant="standard" // <== changed this
              margin="normal"
              required
              value={companyInformation?.vatRate}
              onChange={(e) =>
                setCompanyInformation({
                  ...companyInformation,
                  vatRate: e?.target?.value,
                })
              }
              InputProps={{
                disableUnderline: true,
                fontSize: "12px",
              }}
              type="number"
              placeholder="Enter Vat Rate %"
              sx={{
                width: "190px",
                fontSize: "12px",
                padding: 1,
                borderRadius: 2,
                border: "1px solid black",
                fontFamily: "Poppins",
                fontWeight: "bold",
                margin: 0,
              }}
            />
          </Box>
          
        </Box>

        <Box
          style={{
            display: "flex",
            justifyContent: "space-between",
            width: "400px",
          }}
        >
          <Box style={{ marginTop: 10 }}>
            <Typography
              style={{
                fontFamily: "Poppins",
                fontSize: 18,
                fontWeight: "600",
                textAlign: "left",
              }}
            >
              POS Start Time:
            </Typography>

            <input
              type={"time"}
              value={
                companyInformation?.startTime
                  ? companyInformation.startTime
                  : ""
              }
              onChange={(e) =>
                setCompanyInformation({
                  ...companyInformation,
                  startTime: e?.target?.value,
                })
              }
              placeholder="Start Time"
              style={{
                width: "190px",
                fontSize: "14px",
                padding: 12,
                borderRadius: 10,
                border: "1px solid black",
                fontFamily: "Poppins",
                fontWeight: "bold",
                margin: 0,
              }}
            />
          </Box>

          <Box style={{ marginTop: 10 }}>
            <Typography
              style={{
                fontFamily: "Poppins",
                fontSize: 18,
                fontWeight: "600",
                textAlign: "left",
              }}
            >
              POS End Time:
            </Typography>

            <input
              type={"time"}
              value={companyInformation?.endTime}
              onChange={(e) =>
                setCompanyInformation({
                  ...companyInformation,
                  endTime: e?.target?.value,
                })
              }
              placeholder="End Time"
              style={{
                width: "190px",
                fontSize: "14px",
                padding: 12,
                borderRadius: 10,
                border: "1px solid black",
                fontFamily: "Poppins",
                fontWeight: "bold",
                margin: 0,
              }}
            />
          </Box>
        </Box>

        {userData?.role != "super_admin" && (
          <Box style={{ marginTop: 10 }}>
            <Typography
              style={{
                fontFamily: "Poppins",
                fontSize: 18,
                fontWeight: "600",
                textAlign: "left",
              }}
            >
              POS ACCESS:
            </Typography>

            <Tree
    checkable
    treeData={convertToTreeData(data)}
    checkedKeys={getAllCheckedIds(data)}
    onCheck={onCheck}
    />
          </Box>
        )}

        <CustomButton
          onClick={handleSaveCompanyInformation}
          text="Save Company Information"
          style={{
            width: 400,
            marginTop: 5,
            borderRadius: 2,
            fontSize: "14px",
          }}
        />
      </Box>
      <Modal
        open={emailConnectionModal}
        onClose={() => setEmailConnectionModal(false)}
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            maxHeight: "90vh",
            overflowY: "auto",
            borderRadius: 2,
            width: 500,
          }}
        >
          <Box
            style={{
              padding: 20,
              width: "100%",
              // border: "2px solid",
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
            }}
          >
            <div>
              Add your Appp Password of this email {Information?.companyEmail}{" "}
            </div>
            <Box>
              <Typography
                style={{
                  fontFamily: "Poppins",
                  fontSize: 18,
                  fontWeight: "600",
                  textAlign: "left",
                }}
              >
                App Password:
              </Typography>

              <TextField
                variant="standard" // <== changed this
                margin="normal"
                required
                value={appPassword}
                onChange={(e) => setAppPassword(e.target.value)}
                InputProps={{
                  disableUnderline: true,
                  fontSize: "12px",
                }}
                placeholder="Enter App Password"
                sx={{
                  width: "400px",
                  fontSize: "12px",
                  padding: 1,
                  borderRadius: 2,
                  border: "1px solid black",
                  fontFamily: "Poppins",
                  fontWeight: "bold",
                  margin: 0,
                }}
              />
            </Box>

            <div>
              Eg: If you use G-mail and go to{" "}
              <a
                href="https://myaccount.google.com/apppasswords"
                target="_blank"
              >
                https://myaccount.google.com/apppasswords
              </a>{" "}
              and create app password and add in their To create an app
              password, you need 2-Step Verification on your Google Account. If
              you use 2-Step-Verification and get a "password incorrect" error
              when you sign in, you can try to use an app password.
            </div>
          </Box>

          <Box>
            <CustomButton
              onClick={() => ConnectEmail()}
              style={{ width: "100%" }}
              text="Connect Email"
            />
          </Box>
        </Box>
      </Modal>
    </Box>
  );
}

export default CompanyInformation;
